import { mutatorAction } from 'satcheljs';
import { CalendarCacheUpdateLog } from '../store/schema/CalendarCacheDiagnosticsStore';
import getStore from '../store/store';

export default mutatorAction('insertCacheUpdateLogMutator', function insertCacheUpdateLogMutator(
    cacheUpdateLog: CalendarCacheUpdateLog
) {
    getStore().cacheUpdateLogs.push(cacheUpdateLog);
});
